module.exports = "/_assets/images/theming/hex-characters/corval-hex-ring-oblong-laptop-discussion.png";